// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__tTKFo","search":"Settings_search__7ltAU","filter":"Settings_filter__2aYwr"};